import { useIsBusinessUser } from "../../entities/users/hooks";
import { useFeature } from "../features";
import { PERMISSION, useBusinessPermissions } from "../permissions";

const MANAGE_RECIPIENT_PERMISSIONS = [PERMISSION.BUSINESS.WRITE.RECIPIENT];
const DUAL_APPROVAL_PERMISSIONS = [
  PERMISSION.BUSINESS.WRITE.DUAL_APPROVAL_REQUEST,
];
const APPROVE_ACH_TEMPLATES_PERMISSIONS = [
  PERMISSION.BUSINESS.WRITE.APPROVE_ACH_TEMPLATES,
];
const ACH_PAYMENT_REVERSE_PERMISSIONS = [
  PERMISSION.BUSINESS.WRITE.ACH_PAYMENT_REVERSE,
];
const ACH_PAYMENT_COLLECT_REVERSE_PERMISSIONS = [
  PERMISSION.BUSINESS.WRITE.ACH_PAYMENT_COLLECT_REVERSE,
];

export const useACHPaymentsPermissions = () => {
  const { featureEnabled } = useFeature();

  const isBusinessUser = useIsBusinessUser();
  const achPaymentsEnabled = featureEnabled("ach_payments");
  return achPaymentsEnabled && isBusinessUser;
};

// referring specifically to ach recipients right now
// but will become universal recipients in future
export const useManageRecipientPermission = () => {
  const [hasManageRecipientPermission] = useBusinessPermissions(
    MANAGE_RECIPIENT_PERMISSIONS,
  );

  return hasManageRecipientPermission;
};

export const useDualApprovalPermission = () => {
  const [hasDualApprovalPermission] = useBusinessPermissions(
    DUAL_APPROVAL_PERMISSIONS,
  );

  return hasDualApprovalPermission;
};

export const useApproveAchTemplatesPermission = () => {
  const [hasApproveAchTemplatesPermission] = useBusinessPermissions(
    APPROVE_ACH_TEMPLATES_PERMISSIONS,
  );

  return hasApproveAchTemplatesPermission;
};

export const useACHReverseSendPermission = () => {
  const [hasPermission] = useBusinessPermissions(
    ACH_PAYMENT_REVERSE_PERMISSIONS,
  );
  return hasPermission;
};

export const useACHReverseCollectPermission = () => {
  const [hasPermission] = useBusinessPermissions(
    ACH_PAYMENT_COLLECT_REVERSE_PERMISSIONS,
  );
  return hasPermission;
};
